import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import SharepointFoldersListTable from 'Integrations/components/SharePointFolders/SharePointFoldersListTable';
import { Tab, TabList, TabPanel, Tabs as TabsWrapper } from 'Common/components/tabs';
import HeaderTitle from 'Common/components/PageHeader/HeaderTitle';
import HeaderContainer from 'Common/components/PageHeader/HeaderContainer';
import { AlertWrapper, BoldText, StyledLink } from 'Impact/Impact';
import Icon from 'Common/components/icons/Icon';

const SharePointFoldersList = () => {
	const { t } = useTranslation();
	const [selectedTab, setSelectedTab] = useState(0);

	return (
		<>
			<Helmet>
				<title>{t('Integrations')}</title>
			</Helmet>
			<HeaderContainer>
				<HeaderTitle>{t('Integrations')}</HeaderTitle>
			</HeaderContainer>
			<AlertWrapper>
				<Icon icon="warning" size="small" />
				<h2>
					{t('As of today, ')}
					<BoldText>Pulse will be in frozen state. </BoldText>
					{t("This means that you won't be able to enter or edit any information until Pulse v2 is released. ")}
					<StyledLink
						href="https://www.notion.so/ecoligo/Pulse-migration-All-you-need-to-know-2572e2e27e4080678bf7f28ade021b6c"
						target="_blank"
						rel="noopener noreferrer"
					>
						{t('Read more ')}
					</StyledLink>
					{t('about this.')}
				</h2>
			</AlertWrapper>
			<TabsWrapper selectedIndex={selectedTab} onSelect={setSelectedTab}>
				<TabList>
					<Tab>{t('SharePoint')}</Tab>
				</TabList>
				<TabPanel>
					<SharepointFoldersListTable />
				</TabPanel>
			</TabsWrapper>
		</>
	);
};

export default SharePointFoldersList;
